import { filterArray, reducer, preventDivision, precisionRound, clusterize } from '@/services/tools'

const COUNT_UPDATED = (state, count) => {
  state.count = count
}

const TEMPLATE_PLAYERS_UPDATED = (state, players) => {
  state.templatePlayers = players
}

const USER_PLAYERS_UPDATED = (state, players) => {
  state.userPlayers = players
}

const TEMPLATE_UPDATED = (state, id) => {
  state.templateId = id
}

const STATS_UPDATED = (state, userPlayers) => {
  const allData = {
    nAge: [],
    nHeight: [],
    nWeight: [],
    nCompetition: []
  }
  userPlayers.map(section => {
    section._players.map(player => {
      allData.nAge.push(player.nAge)
      allData.nHeight.push(player.nHeight)
      allData.nWeight.push(player.nWeight)
      allData.nCompetition.push(player.competition)
    })
  })

  // Age stats
  allData.nAge = filterArray(allData.nAge)
  if (allData.nAge.length > 0) {
    state.stats.nAge = precisionRound(allData.nAge.reduce(reducer) / preventDivision(allData.nAge.length), 2).toString().replace('.', ',')
  } else {
    state.stats.nAge = null
  }

  // Height stats
  allData.nHeight = filterArray(allData.nHeight)
  if (allData.nHeight.length > 0) {
    state.stats.nHeight = precisionRound((allData.nHeight.reduce(reducer) * 0.01) / preventDivision(allData.nHeight.length), 2).toString().replace('.', ',')
  } else {
    state.stats.nHeight = null
  }

  allData.nWeight = filterArray(allData.nWeight)
  if (allData.nWeight.length > 0) {
    state.stats.nWeight = precisionRound(allData.nWeight.reduce(reducer) / preventDivision(allData.nWeight.length), 2).toString().replace('.', ',')
  } else {
    state.stats.nWeight = null
  }

  // Competions stat
  allData.nCompetition = filterArray(allData.nCompetition)
  if (allData.nCompetition.length > 0) {
    const cc = clusterize(allData.nCompetition)
    state.stats.nCompetition = precisionRound((cc.max.total * 100) / preventDivision(cc.total), 0).toString().replace('.', ',')
    state.competition.tName = cc.max.element.tName
    state.competition.tUrlPicture = cc.max.element.tUrlPicture
  } else {
    state.stats.nCompetition = null
  }
}

export default {
  COUNT_UPDATED,
  TEMPLATE_PLAYERS_UPDATED,
  TEMPLATE_UPDATED,
  USER_PLAYERS_UPDATED,
  STATS_UPDATED
}



// WEBPACK FOOTER //
// ./src/store/modules/results/mutations.js